<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0">
<span id="Page_40" title="[40]"></span>
<h2 class="nobreak" id="pgepubid00004">III<br class="calibre17"/>
<span class="small">COUSIN BIG SUE</span></h2>
</div>
<p class="calibre3"><span class="smcap">Breeze</span> had heard about Blue Brook Plantation all
his life, but he had never heard about his mother’s
Cousin Big Sue until one hot October afternoon when
he was minding the cow by the spring branch and helping
his mother break in the precious nubbins of corn
and put them in the log barn. Sis called them to come
on home in a hurry! The stepfather had gone to town
hunting work. Maybe he had come home. Sis’s voice
was high and shrill and scared, and Breeze knew something
had happened. These hot days the mother always
worked in the field until first dark because that was the
coolest part of the day, and Sis, who stayed at home and
sewed and patched and cooked, never called anybody
until after the sun went down.</p>
<p class="calibre3">Breeze forgot that the cow was in reach of the low-ground
corn and hurried across the stubby furrows as
fast as his skinny legs could carry him, but he stopped
short when he saw a big fat black woman with a good-natured
smile on her face, standing beside Sis in the
cabin’s back door. Who was she? Why had she come?
Why did Sis look so grieved?</p>
<p class="calibre3">The other children were in the yard, giggling, trying
to hide behind one another, but the woman’s eyes stayed
on Breeze.</p>
<p class="calibre3">“I kin see de likeness!” she laughed. “Lawd, yes!
Dat boy is de pure spit o’ April! De same tar-black<span id="Page_41" title="[41]"></span>
skin. De same owl eyes. A mouth blue as blackberry
stain.”</p>
<p class="calibre3">Breeze had run so fast he was out of breath and his
heart beat against his ribs as he watched his mother kiss
the stranger and go inside the cabin with her. Presently
Sis called him to come in too.</p>
<p class="calibre3">The mother put an arm around him and drew him
up close to her side. Her sleeve was wet with sweat, her
body hot and steamy, but her hand was cold and shaking
like a leaf. How weak and frail she looked beside the
fat outsider, who held out a thick hot hand to shake
Breeze’s. The gold rings on it matched the gold hoop
earrings glittering in her small ears, and they felt hard
as they pressed against his fingers.</p>
<p class="calibre3">In the silence that followed Breeze looked at the big
woman’s sleek smooth face. It was round and tight like
her fleshy body but with dimples in its cheeks like baby
Sonny’s. She took a pair of gold-rimmed spectacles out
of her pocket and put them on, then leaned back in her
chair and laughed a queer gurgling laugh that widened
her flat nostrils and stretched her full lips.</p>
<p class="calibre3">“Lawd, ain’t it funny how dat boy favors his pa!
Dat’s a pity too. A boy-chile ought to favor his ma to
be lucky. I hope e ain’ gwine be de devil April ever
was. April was born wid a caul de same way. Lawd,
e’s a case too!”</p>
<p class="calibre3">Without giving his mother time to answer she talked
on; her son Lijah was like her and her girl, Joy, the
image of Silas, her husband. Thank God, Joy didn’t
have ways like Silas. He was good-looking enough, but
God never made a more trifling creature than Silas. He
ran off and left her seven years ago and she had raised
those two children all by herself. Lijah was in Fluridy
now. Or maybe it was Kintucky, she wasn’t certain
which; but he was the worst man in the town where he<span id="Page_42" title="[42]"></span>
lived. Everybody was scared to meddle with Lijah.
She laughed and rubbed her fat hands together. Nobody
would ever run over her Lijah. He took after her
that way. Now Joy was different. Joy was weak and
easy. But she was a nice girl. She was in town, going
to college, getting educated. Joy wouldn’t rest until she
got a depluma. When she got it, she’d teach school or
marry some fine stylish town man. Joy was a stylish
girl herself. Maybe too slim, now, but she’d thicken out.
When she was Joy’s age, Silas could span her waist
with his two hands. Joy would fatten up too when she
reached a settled age.</p>
<p class="calibre3">Cousin Big Sue rolled out her talk without stopping
to catch one breath, and all the time her small sparkleberry
eyes roved from Breeze’s face to his mother’s, then
back to Breeze again.</p>
<p class="calibre3">The mother sat huddled low in her chair, her forehead
wrinkled, her shoulders drooped. She reached out
and took baby Sonny from Sis, and with fingers that
shook she unbuttoned her dirty sweaty dress to feed him.
For the first time in his life Breeze noticed her poor
ragged underclothes and her bony feet and legs. They
looked so lean and skinny beside Cousin Big Sue’s tight-filled
stockings and wide laced-up shoes.</p>
<p class="calibre3">Two bright tears fell swiftly in baby Sonny’s fuzzy
wool and shone there, two clear drops. Breeze was about
to cry himself for his mother’s stooped body looked so
pitiful. The corners of her mouth were pinched in and
the back of her dress, all darkened with sweat from the
hard work she had been doing, was humped out in two
places by the bones of her thin shoulder-blades. But
baby Sonny bobbed his head in such a funny way as he
seized the long thin breast that came flopping out. He
crowed and kicked his little feet with joy just as if that
ugly flesh was the finest thing in the world. Breeze
forgot himself and laughed out loud.</p>
<p class="calibre3"><span id="Page_43" title="[43]"></span>Cousin Big Sue’s fat hands stroked each other
gently, and the laugh that oozed out of her mouth
squeezed her eyes almost shut.</p>
<p class="calibre3">“Dat boy Breeze is got nice teeth, enty? But Lawd,
his gums sho’ is blue! April’s got ’em too. An’ April’s
wife, Leah, is got ’em. Dat’s dog eat dog, enty? I wish
dis boy didn’ had ’em, but I know e won’t never bite
me. Will you, son?”</p>
<p class="calibre3">Breeze felt so shamefaced he shut his mouth tight
and hung his head, and his mother began telling Big
Sue about the terrible dry-drought. How it had worked
a lot of deviltry since June. The crops had promised to
make a fair yield, and she kept stirring the earth to
encourage them to hold on to their leaves and blossoms,
even if they couldn’t grow. But the hot sun wouldn’t
let a drop of rain fall, no matter how the clouds sailed
overhead full of thunder and lightning. The leaves all
got limp and dry. Sis said they were hanging their heads
to pray, but they stayed limp, then they parched brown
and dried up and fell off. The peas-patch didn’t make
enough hay to stuff a mattress. The corn planted on the
hill looked like dried onions. The patch of corn in the
rich low-ground, close by the spring branch, had done
little better. Mid-summer found every blade with its
hands shut up tight, trying to hold on to what little sap
the sun left. The grass quit trying to be green and the
cow had nothing to eat but the coarse bitter weeds growing
alongside the spring branch. She was nearly gone
dry. What little milk she gave was skimpy and rank,
and turned to clabber soon as it cooled. The cream was
ropy, and the curds tough. When the butter was
churned it wouldn’t gather, but laid down flat like
melted lard.</p>
<p class="calibre3">The hens had quit laying and spent the summer panting
air in and out of wide-open mouths, with their wings
away off from their bodies, trying to get cool. The old<span id="Page_44" title="[44]"></span>
sow had quit rooting and stayed in the mud-hole wallowing,
until the mud baked into squares like an
alligator’s hide. She had no milk for her pigs, and those
that didn’t starve turned into runts.</p>
<p class="calibre3">Winter was coming. Not a leaf of collards was
growing, the few nubbins of corn left wouldn’t make
bread to last until Christmas. God only knew how she’d
feed the children.</p>
<p class="calibre3">When she leaned down to wipe her eyes on her skirt,
baby Sonny raised up his hard little head and jerked it
down on her breast with a hungry butt, and Breeze forgot
again and snickered out. Not that he would ever
make sport of Sonny. Never in the world. He loved
every crinkly tuft of wool on the baby’s head, every tiny
finger and toe. Even if he didn’t grow a bit, his lightness
made him easy to hold. Breeze loved him better
than all the other children put together because he was
small and weak.</p>
<p class="calibre3">Big Sue broke into a bright smile. “Son, I’m sho’
glad you love to laugh. I love to laugh my own self.”
Her narrow eyes sparkled through her gold-rimmed
spectacles, and her wide loose lips spread across her
face. “De people on Blue Brook is almost quit laughin’
since de boll-evils come. But boll-evils don’ fret me. I
cooks at de Big House. An’ no matter if de buckra is at
Blue Brook or up-North whe’ dey stays most o’ de time,
I has all de victuals an’ money I wants. I has more’n I
kin use. It’s de Gawd’s truth. You’ll sho’ have sin, if
you don’ give me dat boy to raise. Po’ as you is, much
mouths as you got to fill, you ought to be glad to git
shet o’ one. You better listen good at all I say. I’ll
train em good. I’ll fatten em up. I’ll learn em to have
manners. Dis same boy might git to be foreman at Blue
Brook yet. E comes from dat foreman breed. You
sho’ ought not to stand in his way. No, ma’am.”</p>
<p class="calibre3"><span id="Page_45" title="[45]"></span>If she wanted a boy-child to raise why didn’t Cousin
Big Sue choose one of the others? Maybe she didn’t like
the way their shirts were unbuttoned, with their naked
bodies showing down to their waists. Their ragged
breeches were not only dirty but ripped open.</p>
<p class="calibre3">Breeze’s heart fluttered like a trapped bird’s. Fright
had him paralyzed so he couldn’t run off and hide. His
mother looked shrunken, withered. A few tears fell
from her eyes as they stared out of the door.</p>
<p class="calibre3">“I bet you ain’t got decent victuals for supper right
now. I got plenty, yonder home.”</p>
<p class="calibre3">Cousin Big Sue’s eyes were riveted on Breeze, as she
declared he’d be far better off with her than here with
his mother, and a house full of starved-out children,
growing up in ignorance and rags. She’d teach him and
train him and raise him to be a fine man, to know how to
do all kinds of work, to make money and wear shoes and
fine clothes like her Lijah.</p>
<p class="calibre3">“April”—she peeped sidewise at the mother when
she spoke the name—“April’s de foreman at Blue Brook,
an’ e’ll help me raise Breeze. E tol’ me so las’ night.”</p>
<p class="calibre3">The mother listened and looked at Sis. Sis slowly
nodded back, yes. Breeze burst out crying. He begged
them not to give him away. He didn’t want to leave
home. He wanted to stay right there and be hungry
and ragged. He liked to grow up in ignorance and sin.</p>
<p class="calibre3">The shed-room was open so that Big Sue saw the
beds covered with old quilts worn into holes. She said
Breeze would have good quilts and a feather-bed at her
house. The softest lightest feather-bed in the world. It
was stuffed with breast feathers plucked off the wild
ducks she’d picked and cooked for the white folks at the
Big House. Breeze would think he was sleeping on air.
She had dry-picked the ducks so the feathers would be
puffy, though scalding would have made picking easier.</p>
<p class="calibre3"><span id="Page_46" title="[46]"></span>She’d buy him a pair of ready-made pants from the
store, and two or three shirts. She’d get shirts with
tails on them like a grown man’s shirt.</p>
<p class="calibre3">After that first outcry Breeze couldn’t make a sound
with his voice, for a lump rose in his throat and choked
him. He’d rather stay at home and do without bread,
or bed.</p>
<p class="calibre3">“Please, please——” he wailed. But his words
were dumb and his crying did no good.</p>
<p class="calibre3">The day was moving. The shadow cast by the china-berry
tree had stretched from the front steps to the
four-o’clocks over on the other side. Big Sue said she
must go. A long walk was ahead, and her feet were not
frisky these days.</p>
<p class="calibre3">Breeze could scarcely take in what had happened.
He was given away. When Big Sue closed her warm,
wet-feeling hand over his and led him away down the
path that followed the deep, wide black river, he
wanted to scream out, to yell that he didn’t want to go.
But he couldn’t. He couldn’t even stop his feet from
stepping side by side with hers, one step after another.</p>
<p class="calibre3">Something about this big fat woman kept his mouth
shut. Even when the long sandy path was behind, and
he could see the ferry-flat, that would take him across
the river, he couldn’t speak, and the throat lump had
swelled to a great big ache in his breast.</p>
<p class="calibre3">When a sudden patter of feet sounded behind him
Breeze looked around expecting to see a fawn go across
the road, but instead, there was Sis, with her arms outspread.
She ran straight to him, fast as she could, and
with a sharp little cry hugged him tight. She pressed
her soft cheek, wet with tears, on his and whispered in
his ear that he must go like a man, and try to be a good
boy. She held him close for a minute, then without
another word let him go, and ran. She was soon hidden<span id="Page_47" title="[47]"></span>
from his eyes by the bend in the road. He strove for
one more glimpse of her, but he could see nothing but
trees and shadows.</p>
<p class="calibre3">They had reached the far end of the island and the
dim road turned to drop down to the river where the
flat waited, floating with one end tied up close to a
cypress knee. Nobody was in sight. Big Sue stopped.
“Whe’ is you, Uncle?” She shouted. Echoes answered
and reechoed. “Come on, Uncle! Le’s go!” She
waited, then grumbled. “Lawd! Uncle’s too deef.”</p>
<p class="calibre3">A few steps nearer the river showed a little old man,
sitting crumpled up with his back against a tree. His
head was dropped forward, his old cap awry, showing
the milk-white wool on his head. Big Sue broke out
laughing and went close enough to him to yell in his ear.
At once he jumped awake, jerked his chin up off his
breast, sat up straight. His eyes, dazed with sleep,
gazed around, groping for the sound. When they found
Big Sue hiding, he joined her laughter with a hearty
cackle that bared his pink toothless gums set in the
midst of the bristling white whiskers that stood out
around his jaws and chin, fiercely denying the bright
twinkle in his eyes.</p>
<p class="calibre3">“Takin’ a li’l’ nap, Uncle? I couldn’t sleep on
Sandy Island, not to save life.”</p>
<p class="calibre3">Yes, he admitted, he had dropped off. No use to lie,
for he’d been caught. Sleep was a tricky thing. A sly-moving
thief. Always stealing time from somebody. He
gave a wide-mouthed yawn, stretched his arms to try the
sleeves of his long-tailed faded black coat, then strove to
get his crooked legs straightened, to unbend his knock-knees,
and get his stumbling feet clear of the rough
footing made by the great puckered roots around the
tree. When he finally reached the clear ground he
appeared to see Breeze for the first time.</p>
<p class="calibre3"><span id="Page_48" title="[48]"></span>“Lawd, Big Sue, you had luck fo’ true! I too glad!
Wha’ you’ name, son? Come shake hands wid Uncle.”</p>
<p class="calibre3">He made a polite bow when he took Breeze’s hand,
his dry old face shone with a kindly smile, his frock
coat opened, showing a flowered waistcoat underneath.</p>
<p class="calibre3">“A good-size boy too. E ought to could plow by
next spring. Sho’! How old you is, son?” Uncle
stood back on his heels, straight as a ram-rod, his eyes
sparkling as he praised Breeze’s looks.</p>
<p class="calibre3">“I gwine on twelve, suh,” Breeze answered. But
Big Sue put her mouth up close to the old man’s ear
and bawled:</p>
<p class="calibre3">“His mammy say e’s gwine on twelve, but e looks
mighty small to me. You t’ink e’s a runt?”</p>
<p class="calibre3">Uncle’s eyes watched her lips.</p>
<p class="calibre3">“No, no, Sue, dis boy ain’ no runt. You feed em up.
E’ll fill out an’ grow. Bread an’ meat all two is been
sca’ce on Sandy Island since de dry-drought hit em las’
summer. You keep de boy’s belly full, an’ dis time nex’
year you wouldn’ know em.”</p>
<p class="calibre3">“I wouldn’ live on such po’ land!” Big Sue bawled
again. “Not me! Dis sand looks white as sugar. T’ank
Gawd, us home yonder is on black land what kin hold
water!”</p>
<p class="calibre3">“You like de black land, enty? No wonder, black
as you is, gal!” Uncle chuckled at his joke.</p>
<p class="calibre3">“Sho’! Gi’ me black land eve’y time! You ain’t so
white you’self, Uncle.”</p>
<p class="calibre3">Uncle missed her last words. He was too busy laughing
and talking.</p>
<p class="calibre3">“You like you own color, enty, gal?”</p>
<p class="calibre3">Big Sue nodded and joined in heartily with his
hollow clattering guffaws.</p>
<p class="calibre3">“Gi’ me de black all de time. White t’ings is too
weakly!” she shouted gaily, as Uncle led the way toward<span id="Page_49" title="[49]"></span>
the flat. Big Sue followed, holding Breeze’s hand tight.
She picked her way down the short sandy hill with slow
uncertain steps.</p>
<p class="calibre3">“I ain’ use to shoes an’ dey hinders my feet in dis
sand,” she explained loudly, but Uncle was busy starting
the flat across the river. Grunting, straining until
veins showed in his forehead, he finally got the waterlogged
hulk to moving by means of a rusty cable and a
curious narrow board with notches cut in one side so it
could clutch the cable tight.</p>
<p class="calibre3">The sun fell lower as they slowly crossed. Colors
of the sky on the still water made a band of flame, of
scarlet and purple down the middle of the dark stream,
that spread out into the marshy forest.</p>
<p class="calibre3">The old ferryman paused in his pulling and muttered,
as he gazed at the sunset; then with a bright look
at Breeze, and a chuckle, he began pulling hard again.
A flock of crows streaked the sky, going home; a lone
fish-hawk sailed not far behind them; tiny swamp
sparrows twittered and chattered.</p>
<p class="calibre3">Night was coming and the whole world knew it. The
wind dropped into a quiet whispering, waiting for the
tide to turn. Every tree and leaf and bough, even the
water itself, was darkening. Squirrels chittered softly
in their nests, a wildcat yeowled gently. Breeze’s
heart, that had been thumping miserably in his breast,
now beat up in his throat and the lump that had risen
when he told his mother good-by swelled bigger and
harder than ever. Tears that had been stinging his eyes
all the way began rolling down his cheeks.</p>
<p class="calibre3">He turned his back, and easing a hand stealthily up
to his face, tried to brush them away. Cousin Big Sue
mustn’t see him cry. Sis said he must be a man and try
to be good.</p>
<p class="calibre3">He suddenly forgot his sorrow when swarms of tiny,<span id="Page_50" title="[50]"></span>
almost invisible insects rose from nowhere, and settled
in his eyes and ears and nostrils and teeth, with a fierce
singing and stinging that was maddening. He took off
his ragged hat and tried to fight them away, but they
ignored its waving. As fast as he killed what seemed
to be handfuls, by crushing them on his face and neck
and bare legs, others took their places. Sand-flies and
mosquitoes were eating him up. Cousin Big Sue had to
fight them too, but Uncle was not troubled at all.</p>
<p class="calibre3">“Is de sand-flies pesterin’ yunnuh?” he asked
mildly.</p>
<p class="calibre3">“Great Gawd, dey sho’ is!”</p>
<p class="calibre3">“Git some sweat out you’ armpits an’ rub on you’
face. Dat’ll run ’em!”</p>
<p class="calibre3">“Do, Uncle! Fo’ Gawd’s sake! I ain’ no filthy ol’
man like you! I washes myself!”</p>
<p class="calibre3">“Wha’ dat you say, daughter?”</p>
<p class="calibre3">Big Sue broke into a laugh. “I ain’ say nuttin!
Not nuttin!”</p>
<p class="calibre3">Uncle calmly worked on, unconscious of what she
said. Sweat trickled over his wrinkled face, but it kept
its pleasant smile. More than once Big Sue opened her
mouth to speak, but closed it without a word, and her
face was as doleful as if, like Breeze, she was lonely and
homesick.</p>
<p class="calibre3">Breeze wondered bitterly why he hadn’t run away
and hidden down in the branch where nobody would
ever find him? Baby partridges, or new hatched
guineas, will sneak under a leaf and stay there until
they die before they’ll let a stranger find them. Why
didn’t he do it? He would rather die by himself in the
woods than be here on his way to live with this strange
woman whose wind was broken.</p>
<p class="calibre3">The sticky mud on the bank had shown no respect
for Big Sue’s wide-laced shoes. It clung to their soles<span id="Page_51" title="[51]"></span>
and stained their shiny tops. The hem of her stiff
starched white apron was streaked with dirt. Everything
here was strange and unfriendly. The water and
trees, the tangled vines and rank undergrowth were all
dark and scary. Snakes and alligators and hog-bears
and jack-o’-lanterns lived in such places. More than
likely hants and plat-eyes and fever and spirits were
thick all around. Suppose he’d see them now, with his
second-sight! He didn’t want to see anything but his
home yonder behind him, and it was too far to see even
the smoke rising out of its low clay chimney. A thick
green dusk had risen up from the earth, cutting off the
shore on the other side of the river.</p>
<p class="calibre3">The cable slapped the water as it drew the flat across.
The old man kept up his grunting and straining. He
was not afraid, although he was so old that the years
had dried up the flesh on his crooked bones. Breeze
jumped sharply, startled and bewildered, when, without
any warning, the old man’s laughter cackled out. Looking
down where the old bent forefinger pointed, he
caught sight of an alligator which settled slowly, noiselessly,
under the water until two eyes and a nose tip made
three small dark bumps above the smooth surface.</p>
<p class="calibre3">“De alligator see you, son!” the old man squeaked
out gleefully, and Big Sue broke into shouts of
laughter.</p>
<p class="calibre3">“Great Gawd,” she cried. “Do look how e gaze at
you, Breeze. E mus’ be hongry! E don’ see how you’s
po’ as a snake! You’ li’l’ bones would pure rattle inside
dat big creeter’s belly.”</p>
<p class="calibre3">Stinging homesickness filled Breeze’s heart. Why
had he come? Truly, this was out of his world. But
there was no way to turn back. None. Shrill piercing
bird-cries that rose and fell out of the sky answered
something that ached in his heart.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?e5e58d9a